<template>
  <q-dialog :model-value="modelValue" @update:model-value="fechar">
    <q-card class="neg-escopo neg-modal neg-modal--largo">
      <q-card-section class="neg-modal__titulo">
        Etapas do quadro
        <div class="neg-sub">Ordem, cor, prazo de retorno, etapa final e visibilidade</div>
      </q-card-section>

      <q-card-section v-if="!emEdicao && !paraExcluir" class="neg-modal__corpo">
        <div v-for="(etapa, indice) in etapasOrdenadas" :key="etapa.id" class="neg-etapa">
          <span class="neg-etapa__cor" :style="{ background: etapa.cor || 'var(--neg-azul)' }"></span>
          <span class="neg-etapa__nome">
            {{ etapa.nome }}
            <div class="neg-sub">{{ descricaoDaEtapa(etapa) }}</div>
          </span>
          <q-btn
            flat
            dense
            icon="keyboard_arrow_up"
            :disable="indice === 0"
            @click="trocarOrdem(indice, indice - 1)"
          >
            <q-tooltip>Subir</q-tooltip>
          </q-btn>
          <q-btn
            flat
            dense
            icon="keyboard_arrow_down"
            :disable="indice === etapasOrdenadas.length - 1"
            @click="trocarOrdem(indice, indice + 1)"
          >
            <q-tooltip>Descer</q-tooltip>
          </q-btn>
          <q-btn
            flat
            dense
            :icon="etapa.visivel_quadro ? 'visibility' : 'visibility_off'"
            :disable="ehUltimaDeTrabalho(etapa)"
            @click="alternarVisibilidade(etapa)"
          >
            <q-tooltip>{{ tooltipDeVisibilidade(etapa) }}</q-tooltip>
          </q-btn>
          <q-btn flat dense icon="edit" @click="editar(etapa)">
            <q-tooltip>Editar</q-tooltip>
          </q-btn>
          <q-btn
            flat
            dense
            icon="delete"
            color="negative"
            :disable="ehUltimaDeTrabalho(etapa)"
            @click="excluir(etapa)"
          >
            <q-tooltip>{{ tooltipDeExclusao(etapa) }}</q-tooltip>
          </q-btn>
        </div>
      </q-card-section>

      <q-card-section v-if="emEdicao" class="neg-modal__corpo">
        <q-input
          v-model="emEdicao.nome"
          autofocus
          dense
          label="Nome da etapa"
          :error="Boolean(erros.nome)"
          :error-message="primeiroErro('nome')"
        />
        <q-input
          v-model="emEdicao.cor"
          dense
          label="Cor"
          :error="Boolean(erros.cor)"
          :error-message="primeiroErro('cor')"
        >
          <template v-slot:append>
            <q-icon name="colorize" class="cursor-pointer">
              <q-popup-proxy transition-show="scale" transition-hide="scale">
                <q-color v-model="emEdicao.cor" no-header-tabs format-model="hex" />
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <q-input
          :model-value="emEdicao.dias_alerta"
          @update:model-value="emEdicao.dias_alerta = $numero($event)"
          dense
          clearable
          type="number"
          label="Prazo de retorno em dias"
          hint="Em branco, a etapa não sugere data de retorno"
          :error="Boolean(erros.dias_alerta)"
          :error-message="primeiroErro('dias_alerta')"
        />
        <q-toggle v-model="emEdicao.encerra" label="Esta etapa encerra o fluxo" />
        <q-toggle v-model="emEdicao.visivel_quadro" label="Aparece no quadro" />
      </q-card-section>

      <q-card-section v-if="paraExcluir" class="neg-modal__corpo">
        <p>
          A etapa <b>{{ paraExcluir.nome }}</b> tem {{ oportunidadesEmUso }}
          {{ oportunidadesEmUso === 1 ? "oportunidade" : "oportunidades" }}. Escolha para onde elas
          vão.
        </p>
        <q-select
          v-model="destinoId"
          dense
          emit-value
          map-options
          label="Mover para"
          option-value="id"
          option-label="nome"
          :options="destinosPossiveis"
        />
      </q-card-section>

      <q-card-actions align="right">
        <template v-if="emEdicao">
          <q-btn flat no-caps label="Voltar" @click="emEdicao = null" />
          <q-btn
            unelevated
            no-caps
            color="primary"
            label="Salvar etapa"
            :loading="salvando"
            @click="salvar"
          />
        </template>
        <template v-else-if="paraExcluir">
          <q-btn flat no-caps label="Voltar" @click="cancelarExclusao" />
          <q-btn
            unelevated
            no-caps
            color="negative"
            label="Mover e excluir"
            :disable="!destinoId"
            :loading="salvando"
            @click="confirmarExclusao"
          />
        </template>
        <template v-else>
          <q-btn flat no-caps label="Fechar" @click="fechar(false)" />
          <q-btn unelevated no-caps color="primary" icon="add" label="Nova etapa" @click="criar" />
        </template>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import negociosMixin from "@/mixins/negocios";

function etapaNova() {
  return {
    id: null,
    nome: "",
    cor: "#2741b5",
    dias_alerta: null,
    encerra: false,
    visivel_quadro: true
  };
}

export default {
  name: "negocios-modal-etapas",

  emits: ["update:modelValue", "mudou"],
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      emEdicao: null,
      paraExcluir: null,
      oportunidadesEmUso: 0,
      destinoId: null,
      salvando: false,
      erros: {}
    };
  },
  computed: {
    ...mapGetters(["negociosEtapas"]),
    etapasOrdenadas() {
      return this.negociosEtapas.slice().sort((a, b) => a.ordem - b.ordem || a.id - b.id);
    },
    etapasDeTrabalhoVisiveis() {
      return this.negociosEtapas.filter(etapa => etapa.visivel_quadro && !etapa.encerra);
    },
    destinosPossiveis() {
      return this.paraExcluir
        ? this.etapasOrdenadas.filter(etapa => etapa.id !== this.paraExcluir.id)
        : [];
    }
  },
  methods: {
    descricaoDaEtapa(etapa) {
      const partes = [];

      partes.push(
        etapa.dias_alerta === null ? "sem prazo" : "prazo de " + etapa.dias_alerta + " dias"
      );

      if (etapa.encerra) {
        partes.push("encerra o fluxo");
      }

      if (!etapa.visivel_quadro) {
        partes.push("oculta do quadro");
      }

      return partes.join(" · ");
    },
    ehUltimaDeTrabalho(etapa) {
      return (
        this.etapasDeTrabalhoVisiveis.length === 1 && this.etapasDeTrabalhoVisiveis[0].id === etapa.id
      );
    },
    tooltipDeVisibilidade(etapa) {
      if (this.ehUltimaDeTrabalho(etapa)) {
        return "O quadro precisa de ao menos uma etapa visível que não encerre o fluxo";
      }

      return etapa.visivel_quadro ? "Esconder do quadro" : "Mostrar no quadro";
    },
    tooltipDeExclusao(etapa) {
      return this.ehUltimaDeTrabalho(etapa)
        ? "O quadro precisa de ao menos uma etapa visível que não encerre o fluxo"
        : "Excluir";
    },
    criar() {
      this.erros = {};
      this.emEdicao = etapaNova();
    },
    editar(etapa) {
      this.erros = {};
      this.emEdicao = { ...etapa };
    },
    salvar() {
      this.salvando = true;
      this.erros = {};

      const id = this.emEdicao.id;
      const dados = {
        nome: this.emEdicao.nome,
        cor: this.emEdicao.cor,
        dias_alerta: this.emEdicao.dias_alerta === "" ? null : this.emEdicao.dias_alerta,
        encerra: this.emEdicao.encerra,
        visivel_quadro: this.emEdicao.visivel_quadro
      };

      this.$store.dispatch("salvarNegociosEtapa", { id, dados }).then(resposta => {
        this.salvando = false;

        if (!resposta.success) {
          this.erros = resposta.errors || {};
          this.avisar(resposta.message, "orange");
          return;
        }

        this.emEdicao = null;
        this.avisar(resposta.message, "green");
        this.$emit("mudou");
      });
    },
    alternarVisibilidade(etapa) {
      const dados = { visivel_quadro: !etapa.visivel_quadro };

      this.$store.dispatch("salvarNegociosEtapa", { id: etapa.id, dados }).then(resposta => {
        this.avisar(resposta.message, resposta.success ? "green" : "orange");

        if (resposta.success) {
          this.$emit("mudou");
        }
      });
    },
    trocarOrdem(de, para) {
      const primeira = this.etapasOrdenadas[de];
      const segunda = this.etapasOrdenadas[para];

      this.$store
        .dispatch("salvarNegociosEtapa", { id: primeira.id, dados: { ordem: para + 1 } })
        .then(() =>
          this.$store.dispatch("salvarNegociosEtapa", {
            id: segunda.id,
            dados: { ordem: de + 1 }
          })
        )
        .then(() => this.$emit("mudou"));
    },
    excluir(etapa) {
      this.$store.dispatch("excluirNegociosEtapa", { id: etapa.id }).then(resposta => {
        if (resposta.success) {
          this.avisar(resposta.message, "green");
          this.$emit("mudou");
          return;
        }

        if (resposta.oportunidades) {
          this.paraExcluir = etapa;
          this.oportunidadesEmUso = resposta.oportunidades;
          this.destinoId = null;
          return;
        }

        this.avisar(resposta.message, "orange");
      });
    },
    cancelarExclusao() {
      this.paraExcluir = null;
      this.destinoId = null;
    },
    confirmarExclusao() {
      this.salvando = true;

      this.$store
        .dispatch("excluirNegociosEtapa", {
          id: this.paraExcluir.id,
          etapaDestinoId: this.destinoId
        })
        .then(resposta => {
          this.salvando = false;
          this.avisar(resposta.message, resposta.success ? "green" : "orange");

          if (resposta.success) {
            this.cancelarExclusao();
            this.$emit("mudou");
          }
        });
    },
    fechar(aberto) {
      this.emEdicao = null;
      this.cancelarExclusao();
      this.$emit("update:modelValue", aberto === true);
    }
  }
};
</script>
